export const COLORS = {
  OXYGEN7_PURPLE: "#6F3B96",
  LINK_BLUE: "#1b6ac9",
  disabledBg: "#f2f2f2",
};